import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  getPageSettings,
  setPageSettings,
  toggleHelpDocumenti,
} from '../../../actions/Buy'
import { getCmsAutoV4 } from '../../../actions/noleggia/Cms'
import { closeSlackPopUp } from '../../../actions/SlackWebhook'
import { btoaUrlSafe } from '../../../utils/btoa'
import ErrorModal from '../../buy/dumb/modals/ErrorModal'
import SpinLoader from '../../dumb/SpinLoader'
import FlowBar from '../../FlowBar'
import Metadata from '../../Metadata'
import BackToProductModal from '../../modal/BackToProductModal'
import DocumentiHelperModal from '../dumb/DocumentiHelperModal'
import NoleggiaHeader from '../dumb/NoleggiaHeader'

class NoleggiaWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showExitModal: false,
    }
    this.state.idAuto = this.props.idAuto || window.brumbrum.id_auto
    this.onLogoClick = this.onLogoClick.bind(this)
  }

  componentDidMount() {
    if (
      !('id_auto' in this.props.product) ||
      this.props.product.id_auto !== this.state.idAuto
    ) {
      const payloadPageSettings = {
        uri: `${window.brumbrum.url_api}/cms/p/v4/page-settings/${btoaUrlSafe(
          window.location.pathname
        )}`,
        method: 'GET',
        callback: setPageSettings,
      }

      Promise.all([
        this.props.getCmsAutoV4(this.state.idAuto),
        this.props.getPageSettings(payloadPageSettings),
      ])
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.ui.settings.phoneNumber !== prevProps.ui.settings.phoneNumber
    ) {
      // il numero di telefono e' usato nel template twig che ad ora non conviene rifattorizzare
      $("a[href='tel:00390284582']").attr(
        'href',
        this.props.ui.settings.phoneNumber
      )

      /**
       * Bisogna inizializzare dataLayer solo una volta
       * productType e pageType noon dovrebbero cambiare
       * quindi li settiamo solo ad inizializzazione dataLayer
       */
      if (prevProps.ui.settings.phoneNumber === undefined) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ pageType: this.props.ui.settings.pageType })
        window.dataLayer.push({
          productType: this.props.ui.settings.productType,
        })
        window.dataLayer.push({ route: 'Sellout' })
        window.dataLayer.push({ event: 'routeChange' })
      }
    }
  }

  onLogoClick() {
    this.setState({
      showExitModal: true,
    })
  }

  render() {
    return (
      <div>
        <Metadata isNlt />

        <NoleggiaHeader
          onLogoClick={this.onLogoClick}
          router={this.props.router}
          ui={this.props.ui}
        />

        <FlowBar {...this.props} flowType={'rent'} router={this.props.router} />

        {this.props.children}

        <ErrorModal
          error={this.props.error}
          errorType={this.props.error.type || 'generic'}
          onClose={this.props.closeSlackPopUp}
          product={this.props.product}
          show={this.props.error.display}
        />
        <SpinLoader ui={this.props.ui} />

        <DocumentiHelperModal
          display={!!this.props.helpDocumenti}
          onClose={() => {
            this.props.toggleHelpDocumenti(false)
          }}
          variant="simplemodal__popup--full-height simplemodal__popup--full-width"
        />

        {this.state.showExitModal && (
          <BackToProductModal
            koFn={() => this.setState({ showExitModal: false })}
            okFn={() => (window.location.href = `${this.props.product.url}`)}
          />
        )}
      </div>
    )
  }
}

NoleggiaWrapper.propTypes = {
  children: PropTypes.element,
  closeSlackPopUp: PropTypes.func,
  customer: PropTypes.object,
  error: PropTypes.object,
  getCmsAutoV4: PropTypes.func,
  idAuto: PropTypes.string,
  product: PropTypes.object,
  reroute: PropTypes.func,
  ui: PropTypes.object,
  helpDocumenti: PropTypes.bool.isRequired,
  toggleHelpDocumenti: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  ui: state.ui,
  error: state.error,
  product: state.product,
  helpDocumenti: state.ui.buyHelperDocumenti,
})

export default connect(mapStateToProps, {
  getCmsAutoV4,
  getPageSettings,
  closeSlackPopUp,
  toggleHelpDocumenti,
})(NoleggiaWrapper)
